module.exports = __webpack_public_path__ + "static/img/box.08f4fac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/box.png
// module id = 2NMD
// module chunks = 1